import React, { useState } from "react";
import Dashboard from "../../templates/Dashboard";
import KeysManagement from "../../modules/KeysManagement";
const Components = {
  KeysManagement,
};

export default (props) => {
  const [loading, setLoading] = useState(false);
  const KeysMgtComp = Components[props.Comp];
  return (
    <Dashboard load={loading}>
      <KeysMgtComp />
    </Dashboard>
  );
};
